import React from "react";

const CheckIcon = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <circle cx="10" cy="10" r="9" fill="#E6F7EE" stroke="#00A653" strokeWidth="2" />
    <path
      d="M6.5 10.5L9 13L14 8"
      stroke="#00A653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckIcon;
